<template>
  <div class="flex w-full flex-wrap justify-end gap-2">
    <Button variant="textonly" @click="emit('close')">{{
      $t('g.close')
    }}</Button>
    <Button variant="secondary" @click="emit('subscribe')">
      {{ $t('subscription.required.subscribe') }}
    </Button>
  </div>
</template>

<script setup lang="ts">
import Button from '@/components/ui/button/Button.vue'

const emit = defineEmits<{
  close: []
  subscribe: []
}>()
</script>
